
import {Element} from '@chaysehartsuff/active-html';
import {PlusIcon} from '@chaysehartsuff/active-html';
import {PencilIcon} from '@chaysehartsuff/active-html';
import {ThreeDotsIcon} from '@chaysehartsuff/active-html';
import {Button} from '@chaysehartsuff/active-html';

/**
 * Basic toolset for adding/removing entities from blog
 */
export default class BlogToolBar extends Element {

    rootTag = 'div';

    /** ---- EVENTS ----- */
    /**
     * Event fired when a new blog item is added.
     */
    static get newItemEvent() { return 'newItem'; }
    /**
     * Event fired when the blog metadata is edited.
     */
    static get editBlogEvent() { return 'editBlog'; }
    /**
     * Event fired when the quick action button is clicked.
     */
    static get quickActionEvent() { return 'quickAction'; }




    constructor(

    ) {
        super();
        this.addClass('w-full flex justify-between items-center p-2');
        this.addClass('relative group');

        const plusIcon = new PlusIcon();
        plusIcon.addClass('w-5 h-5 text-gray-700');

        const pencilIcon = new PencilIcon();
        pencilIcon.addClass('w-5 h-5 text-gray-700');

        const threeDotsIcon = new ThreeDotsIcon();
        threeDotsIcon.addClass('w-5 h-5 text-gray-700');

        const addButton = new Button();
        addButton.onEvent('click', this.onNewItem.bind(this));
        addButton.addClass('p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors');

        const editButton = new Button();
        editButton.onEvent('click', this.onEditBlog.bind(this));
        editButton.addClass('p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors');

        const quickActionButton = new Button();
        quickActionButton.onEvent('click', this.onQuickAction.bind(this));
        quickActionButton.addClass('p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors');

        
        addButton.addContent(plusIcon);
        this.addContent(addButton);

        const rightActionGroup = new Element();
        rightActionGroup.addClass('flex space-x-2');

        editButton.addContent(pencilIcon);
        rightActionGroup.addContent(editButton);
        
        quickActionButton.addContent(threeDotsIcon);
        rightActionGroup.addContent(quickActionButton);

        this.addContent(rightActionGroup);
    }

    onNewItem(e) {
        this.event(BlogToolBar.newItemEvent, e);
    }

    onEditBlog(e) {
        this.event(BlogToolBar.editBlogEvent, e);
    }

    onQuickAction(e) {
        this.event(BlogToolBar.quickActionEvent, e);
    }

}
